import { withStyles } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Button, Card } from '#shared/components/UI';
import { SettingsCardImgsMap } from './SettingsCardImg';
import { SettingsItem } from '../types';
import styles from './SettingsCard.module.scss';

const cn = withStyles(styles);

type SettingsCardProps = {
  item: SettingsItem;
  onClickDetails: () => void;
};

export default function SettingsCard({ item, onClickDetails }: SettingsCardProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.Settings.Card' });
  const resolvedButtonLabel = item.buttonLabel ?? t('detailsButton', { defaultValue: 'Details' });

  return (
    <Card className={cn('card')}>
      <div className={cn('header')}>
        <img className={cn('icon')} src={SettingsCardImgsMap[item.icon].src} alt="" />

        <div className={cn('labels')}>
          <div className={cn('title')}>{item.title}</div>
          {item.subtitle && <p className={cn('subtitle')}>{item.subtitle}</p>}
        </div>
      </div>

      {item.description && <p className={cn('description')}>{item.description}</p>}

      {item.isLocked ? (
        <Button
          id="details"
          colorScheme="primary"
          size="small"
          iconLeftProps={{ icon: 'lock', fillAmount: 1 }}
          onClick={onClickDetails}
        >
          {resolvedButtonLabel}
        </Button>
      ) : (
        <Button id="details" colorScheme="primary" size="small" onClick={onClickDetails}>
          {resolvedButtonLabel}
        </Button>
      )}
    </Card>
  );
}
